var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Practice",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#231F20"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3173",
    points: "9.5 21.4983 0.5 21.4983 0.5 0.4983 11.5 0.4983 16.5 5.4983 16.5 12.9983"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3174",
    strokeLinecap: "round",
    points: "11.5 0.4983 11.5 5.4983 16.5 5.4983"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3175",
    strokeLinecap: "round",
    points: "16 22.4998 12.5 23.4998 13.5 19.9998 21.001 12.4988 23.501 14.9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0012,14.4983 L21.5012,16.9983",
    id: "Stroke-3176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,19.9998 L16,22.4998",
    id: "Stroke-3177",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.6362d6b5a2ac51be151c50d51d043c03.svg";
export { ForwardRef as ReactComponent };